import styled, { css, keyframes } from "styled-components";
import Keyframes from "theme/keyframes";

type ParticleProps = {
  color: string;
  colorT: string;
  parts: number;
  partsSize: string;
};

const dur = 1;

const Container = styled.div`
  font-size: 24px;
  filter: blur(0.5px);
  margin: 0 auto;
  position: relative;
`;

const createParticleParts = (parts: number, partSize: string) => {
  const particleParts = [...Array(parts).keys()].map((value) => {
    const p = value + 1;

    return `
      &:nth-of-type(${p}) {
        animation-delay: ${dur * Math.random()}s;
        left: calc((100% - ${partSize}) * (${(p - 1) / parts}));
      }
    `;
  });

  return particleParts.join("\n");
};

const Particle = styled.div`
  animation: ${Keyframes.flameRise} ${dur}s ease-in infinite;
  background-image: ${(props: ParticleProps) => css`radial-gradient(${props.color} 20%, ${props.colorT} 70%)`};
  border-radius: 50%;
  mix-blend-mode: screen;
  opacity: 0;
  position: absolute;
  bottom: 0;
  width: ${(props: ParticleProps) => props.partsSize};
  height: ${(props: ParticleProps) => props.partsSize};

  ${(props: ParticleProps) => createParticleParts(props.parts, props.partsSize)}
`;

const FlameStyles = {
  Container,
  Particle,
};
export default FlameStyles;
